"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("./..");
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ThemeModeToggler = () => {
  const theme = (0, _styles.useTheme)();
  const {
    themeToggler
  } = theme;
  const {
    mode
  } = theme.palette;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_.Button, {
    variant: 'outlined',
    onClick: () => themeToggler(),
    "aria-label": "Theme selector",
    title: "Theme selector",
    color: mode === 'light' ? 'primary' : 'secondary',
    sx: {
      borderRadius: 2,
      minWidth: 'auto',
      padding: 0.5,
      borderColor: (0, _styles.alpha)(theme.palette.divider, 0.2)
    },
    children: mode === 'light' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      width: 20,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
      width: 20,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      })
    })
  });
};
var _default = exports.default = ThemeModeToggler;